import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-1e163306"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "myLike"
};
const _hoisted_2 = {
  class: "cont"
};
const _hoisted_3 = {
  class: "cont_body"
};
const _hoisted_4 = {
  class: "tabs_cont"
};
const _hoisted_5 = {
  key: 0,
  class: "recharge_box_item"
};
const _hoisted_6 = {
  class: "tabs_cont"
};
const _hoisted_7 = {
  key: 0,
  class: "recharge_box_item"
};
const _hoisted_8 = {
  class: "tabs_cont"
};
const _hoisted_9 = {
  key: 0,
  class: "recharge_box_item"
};
const _hoisted_10 = {
  class: "cont_body"
};
const _hoisted_11 = {
  class: "tabs_cont"
};
const _hoisted_12 = {
  key: 0,
  class: "recharge_box_item"
};
const _hoisted_13 = {
  class: "tabs_cont"
};
const _hoisted_14 = {
  key: 0,
  class: "recharge_box_item"
};
const _hoisted_15 = {
  class: "details_page_app"
};
const _hoisted_16 = {
  class: "head_title"
};

const _hoisted_17 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "title"
}, "详情", -1));

const _hoisted_18 = {
  class: "cont_body_app"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_icon = _resolveComponent("van-icon");

  const _component_AskForVideoList = _resolveComponent("AskForVideoList");

  const _component_van_list = _resolveComponent("van-list");

  const _component_no_data = _resolveComponent("no-data");

  const _component_van_tab = _resolveComponent("van-tab");

  const _component_van_tabs = _resolveComponent("van-tabs");

  const _component_MicroHeadlinesList = _resolveComponent("MicroHeadlinesList");

  const _component_ask_for_video_details = _resolveComponent("ask-for-video-details");

  const _component_microHeadlines_details = _resolveComponent("microHeadlines-details");

  const _component_van_popup = _resolveComponent("van-popup");

  return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", {
    class: "head_titles head_top_20",
    onClick: _cache[0] || (_cache[0] = $event => $setup.close(1))
  }, [_createVNode(_component_van_icon, {
    size: "22",
    name: "arrow-left"
  })]), _createElementVNode("div", _hoisted_2, [_createVNode(_component_van_tabs, {
    active: _ctx.active,
    "onUpdate:active": _cache[11] || (_cache[11] = $event => _ctx.active = $event),
    "line-height": "0",
    swipeable: "",
    animated: "",
    "title-active-color": "#9533ea",
    "title-inactive-color": "#000000",
    color: "transparent",
    onClickTab: _ctx.onClickTab,
    background: "transparent"
  }, {
    default: _withCtx(() => [_createVNode(_component_van_tab, {
      title: "求片"
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_3, [_createVNode(_component_van_tabs, {
        shrink: "",
        "line-height": "0",
        swipeable: "",
        animated: "",
        "title-active-color": "#9533ea",
        "title-inactive-color": "#000000",
        color: "transparent",
        background: "transparent"
      }, {
        default: _withCtx(() => [_createVNode(_component_van_tab, {
          title: "我的求片"
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_4, [_createVNode(_component_van_list, {
            loading: $setup.loading1,
            "onUpdate:loading": _cache[1] || (_cache[1] = $event => $setup.loading1 = $event),
            error: $setup.error1,
            "onUpdate:error": _cache[2] || (_cache[2] = $event => $setup.error1 = $event),
            finished: $setup.finished1,
            offset: 20,
            "error-text": "请求失败，点击重新加载",
            "finished-text": "-我也是有底线的-",
            "loading-text": "正在获取数据...",
            onLoad: $setup.onLoad1
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.myQpList, (item, index) => {
              return _openBlock(), _createBlock(_component_AskForVideoList, {
                key: index,
                onClick: $event => $setup.showDetails(item, 'qp', 'my'),
                data: item
              }, null, 8, ["onClick", "data"]);
            }), 128))]),
            _: 1
          }, 8, ["loading", "error", "finished", "onLoad"]), $setup.myQpList.length === 0 && !$setup.loading1 ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createVNode(_component_no_data, {
            color: "#ffffff"
          })])) : _createCommentVNode("", true)])]),
          _: 1
        }), _createVNode(_component_van_tab, {
          title: "我的喜欢"
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_6, [_createVNode(_component_van_list, {
            loading: $setup.loading2,
            "onUpdate:loading": _cache[3] || (_cache[3] = $event => $setup.loading2 = $event),
            error: $setup.error2,
            "onUpdate:error": _cache[4] || (_cache[4] = $event => $setup.error2 = $event),
            finished: $setup.finished2,
            offset: 20,
            "error-text": "请求失败，点击重新加载",
            "finished-text": "-我也是有底线的-",
            "loading-text": "正在获取数据...",
            onLoad: $setup.onLoad2
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.myLikeList, (item, index) => {
              return _openBlock(), _createBlock(_component_AskForVideoList, {
                key: index,
                onClick: $event => $setup.showDetails(item, 'qp'),
                data: item
              }, null, 8, ["onClick", "data"]);
            }), 128))]),
            _: 1
          }, 8, ["loading", "error", "finished", "onLoad"]), $setup.myLikeList.length === 0 && !$setup.loading2 ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_createVNode(_component_no_data, {
            color: "#ffffff"
          })])) : _createCommentVNode("", true)])]),
          _: 1
        }), _createVNode(_component_van_tab, {
          title: "我的推荐"
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_8, [_createVNode(_component_van_list, {
            loading: $setup.loading3,
            "onUpdate:loading": _cache[5] || (_cache[5] = $event => $setup.loading3 = $event),
            error: $setup.error3,
            "onUpdate:error": _cache[6] || (_cache[6] = $event => $setup.error3 = $event),
            finished: $setup.finished3,
            offset: 20,
            "error-text": "请求失败，点击重新加载",
            "finished-text": "-我也是有底线的-",
            "loading-text": "正在获取数据...",
            onLoad: $setup.onLoad3
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.myTjList, (item, index) => {
              return _openBlock(), _createBlock(_component_AskForVideoList, {
                key: index,
                onClick: $event => $setup.showDetails(item, 'qp'),
                data: item
              }, null, 8, ["onClick", "data"]);
            }), 128))]),
            _: 1
          }, 8, ["loading", "error", "finished", "onLoad"]), $setup.myTjList.length === 0 && !$setup.loading3 ? (_openBlock(), _createElementBlock("div", _hoisted_9, [_createVNode(_component_no_data, {
            color: "#ffffff"
          })])) : _createCommentVNode("", true)])]),
          _: 1
        })]),
        _: 1
      })])]),
      _: 1
    }), _createVNode(_component_van_tab, {
      title: "微头条"
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_10, [_createVNode(_component_van_tabs, {
        shrink: "",
        "line-height": "0",
        swipeable: "",
        animated: "",
        "title-active-color": "#9533ea",
        "title-inactive-color": "#000000",
        color: "transparent",
        background: "transparent"
      }, {
        default: _withCtx(() => [_createVNode(_component_van_tab, {
          title: "我发布的"
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_11, [_createVNode(_component_van_list, {
            loading: $setup.loading4,
            "onUpdate:loading": _cache[7] || (_cache[7] = $event => $setup.loading4 = $event),
            error: $setup.error4,
            "onUpdate:error": _cache[8] || (_cache[8] = $event => $setup.error4 = $event),
            finished: $setup.finished4,
            offset: 20,
            "error-text": "请求失败，点击重新加载",
            "finished-text": "-我也是有底线的-",
            "loading-text": "正在获取数据...",
            onLoad: $setup.onLoad4
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.wfbdList, (item, index) => {
              return _openBlock(), _createBlock(_component_MicroHeadlinesList, {
                key: index,
                onClick: $event => $setup.showDetails(item, 'tt'),
                data: item
              }, null, 8, ["onClick", "data"]);
            }), 128))]),
            _: 1
          }, 8, ["loading", "error", "finished", "onLoad"]), $setup.wfbdList.length === 0 && !$setup.loading4 ? (_openBlock(), _createElementBlock("div", _hoisted_12, [_createVNode(_component_no_data, {
            color: "#ffffff"
          })])) : _createCommentVNode("", true)])]),
          _: 1
        }), _createVNode(_component_van_tab, {
          title: "我喜欢的"
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_13, [_createVNode(_component_van_list, {
            loading: $setup.loading5,
            "onUpdate:loading": _cache[9] || (_cache[9] = $event => $setup.loading5 = $event),
            error: $setup.error5,
            "onUpdate:error": _cache[10] || (_cache[10] = $event => $setup.error5 = $event),
            finished: $setup.finished5,
            offset: 20,
            "error-text": "请求失败，点击重新加载",
            "finished-text": "-我也是有底线的-",
            "loading-text": "正在获取数据...",
            onLoad: $setup.onLoad5
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.wxhdList, (item, index) => {
              return _openBlock(), _createBlock(_component_MicroHeadlinesList, {
                key: index,
                onClick: $event => $setup.showDetails(item, 'tt'),
                data: item
              }, null, 8, ["onClick", "data"]);
            }), 128))]),
            _: 1
          }, 8, ["loading", "error", "finished", "onLoad"]), $setup.wxhdList.length === 0 && !$setup.loading5 ? (_openBlock(), _createElementBlock("div", _hoisted_14, [_createVNode(_component_no_data, {
            color: "#ffffff"
          })])) : _createCommentVNode("", true)])]),
          _: 1
        })]),
        _: 1
      })])]),
      _: 1
    })]),
    _: 1
  }, 8, ["active", "onClickTab"])])]), _createVNode(_component_van_popup, {
    show: $setup.showDetailsPopul,
    "onUpdate:show": _cache[12] || (_cache[12] = $event => $setup.showDetailsPopul = $event),
    class: "popup_coentent",
    overlay: false,
    teleport: "#app",
    position: "right"
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_15, [_createElementVNode("div", _hoisted_16, [_createVNode(_component_van_icon, {
      size: "22",
      name: "arrow-left",
      onClick: $setup.close
    }, null, 8, ["onClick"]), _hoisted_17]), _createElementVNode("div", _hoisted_18, [$setup.type === 'qp' ? (_openBlock(), _createBlock(_component_ask_for_video_details, {
      isMy: $setup.isMy,
      key: $setup.key,
      id: $setup.ask_video_id
    }, null, 8, ["isMy", "id"])) : _createCommentVNode("", true), $setup.type === 'tt' ? (_openBlock(), _createBlock(_component_microHeadlines_details, {
      key: $setup.key,
      id: $setup.head_lines_id
    }, null, 8, ["id"])) : _createCommentVNode("", true)])])]),
    _: 1
  }, 8, ["show"])], 64);
}